const configuration = {
  development: {
    // baseUrl: "http://192.168.1.8:1337",
    // baseUrl: "http://192.168.200.123:1337",
    baseUrl: "https://emmaapi.eu-gb.mybluemix.net",
    // baseUrl: "http://localhost:1337",
    //baseUrl: "https://emma-api.foodiestrip.co.uk",

    blobBaseUrl: "https://foodiestrip.blog",
    imageRoot: "https://cdn.foodiestrip.com/",
    cdn: "https://cdn.foodiestrip.com/",
    login: "http://localhost:3000/signin",
    default_image: "/src/assets/img/image_placeholder.jpg",
    supportedLanguages: {
      "2letters": ["en", "it"],
      "4letters": [],
    },
    paypal: {
      env: "development",
      sandboxID:
        "AYQ3ANFfkgNnVrqbVBTHrkAQ78dOBHW8DkxPuaIBS4wB7i2j5E3afRN5Q8TjeZiOYDgX6Tn3jNNwLPgR",
      productionID: "",
    },
    links: {
      it: {
        privacy_policy: "https://www.rnb4culture.com/emma/privacypolicy.html",
        terms_and_condition:
          "https://foodiestrip.blog/note-legali/termini-e-condizioni/",
      },
      en: {
        privacy_policy: "https://www.rnb4culture.com/emma/privacypolicy.html",
        terms_and_condition:
          "https://foodiestrip.blog/en/legal/terms-and-conditions/",
      },
    },
  },
  staging: {
    baseUrl: "https://emmaapi.eu-gb.mybluemix.net",
    blobBaseUrl: "https://foodiestrip.blog",
    imageRoot: "https://cdn.foodiestrip.com/",
    cdn: "https://cdn.foodiestrip.com/",
    login: "https://login.foodiestrip.com/",
    default_image: "/src/assets/img/image_placeholder.jpg",
    supportedLanguages: {
      "2letters": ["en", "it"],
      "4letters": [],
    },
    paypal: {
      env: "development",
      sandboxID:
        "AYQ3ANFfkgNnVrqbVBTHrkAQ78dOBHW8DkxPuaIBS4wB7i2j5E3afRN5Q8TjeZiOYDgX6Tn3jNNwLPgR",
      productionID: "",
    },
    links: {
      it: {
        privacy_policy: "https://www.rnb4culture.com/emma/privacypolicy.html",
        terms_and_condition:
          "https://foodiestrip.blog/note-legali/termini-e-condizioni/",
      },
      en: {
        privacy_policy: "https://www.rnb4culture.com/emma/privacypolicy.html",
        terms_and_condition:
          "https://foodiestrip.blog/en/legal/terms-and-conditions/",
      },
    },
  },
  production: {
    baseUrl: "https://emmaapi.eu-gb.mybluemix.net",
    blobBaseUrl: "https://foodiestrip.blog",
    imageRoot: "https://cdn.foodiestrip.com/",
    cdn: "https://cdn.foodiestrip.com/",
    login: "https://login.foodiestrip.com/",
    default_image: "/src/assets/img/image_placeholder.jpg",
    supportedLanguages: {
      "2letters": ["en", "it"],
      "4letters": [],
    },
    paypal: {
      env: "production",
      sandboxID:
        "AYQ3ANFfkgNnVrqbVBTHrkAQ78dOBHW8DkxPuaIBS4wB7i2j5E3afRN5Q8TjeZiOYDgX6Tn3jNNwLPgR",
      productionID: "",
    },
    links: {
      it: {
        privacy_policy: "https://www.rnb4culture.com/emma/privacypolicy.html",
        terms_and_condition:
          "https://foodiestrip.blog/note-legali/termini-e-condizioni/",
      },
      en: {
        privacy_policy: "https://www.rnb4culture.com/emma/privacypolicy.html",
        terms_and_condition:
          "https://foodiestrip.blog/en/legal/terms-and-conditions/",
      },
    },
  },
};

export default configuration;
